angular.module('env.data.services.omqlAliasBuilder', [])

    //"restModelField": "omqlAlias"
    .constant('OMQL_ORDER_ITEM_ALIASES', {
        "step": "Step",
        "stepCode": "Step.Code",
        "createdBy": "CreatedBy.Name",
        "assignedCentre": "AssignedCentre",
        "assignedCentre.address": "AssignedCentreAddress",
        "order": "Order",
        "customer": "Customer",
        "centre": "Centre",
        "order.customer": "Customer",
        "order.centre": "Centre",
        "centre.address": "CentreAddress",
        "customer.address": "CustomerAddress",
        "deliveryAddress": "DeliveryAddress"
    })

    .constant('OMQL_ORDER_ALIASES', {
        "createdBy": "CreatedBy.Name",
        "customer": "Customer",
        "centre": "Centre",
        "centre.address": "CentreAddress",
        "customer.address": "CustomerAddress",
        "deliveryAddress": "DeliveryAddress"
    })

    .service('omqlAliasBuilder', function (OMQL_ORDER_ITEM_ALIASES, OMQL_ORDER_ALIASES, gettextCatalog) {
            var _this = this;

            _.extend(_this, {
                mapFieldToOrderItemAlias: mapFieldToOrderItemAlias,
                mapFieldToOrderAlias: mapFieldToOrderAlias,
                buildOperatorQuery: buildOperatorQuery
            });

            return _this;

            //1. Replace '$model.customFields.' with ''
            //2. Replace '$model.' with ''
            //3. Replace substring from 0 to last . with corresponding token from aliases dictionary, if found.
            //4. Make every letter after . to be capital
            function mapFieldInternal(restModelField, defaultPrefix, aliasDictionary) {
                var keyToFind = restModelField.replaceAll("$model.customFields.", "").replaceAll("$model.", "");
                if (_.string.contains(keyToFind, ".")) {
                    keyToFind = aliasDictionary[_.str.strLeftBack(keyToFind, ".")] + ".";
                } else if (aliasDictionary[keyToFind]) {
                    keyToFind = aliasDictionary[keyToFind];
                    if (_.string.contains(keyToFind, ".")) {
                        return keyToFind;
                    }
                } else {
                    keyToFind = defaultPrefix + ".";
                }
                var field = _.str(restModelField).strRightBack(".").capitalize().value();

                return keyToFind + field;
            }

            function mapFieldToOrderItemAlias(restModelField) {
                return mapFieldInternal(restModelField, "OrderItem", OMQL_ORDER_ITEM_ALIASES);
            }

            function mapFieldToOrderAlias(restModelField) {
                return mapFieldInternal(restModelField, "Order", OMQL_ORDER_ALIASES);
            }

            function buildOperatorQuery(operator, field, value) {
                var queryString = "";

                var omqlDateString = function (date) {
                    if (!date || !angular.isDate(date) && date.toString() == "Invalid Date") {
                        return "#001-01-01T00:00:00.000Z#"; //omql date min value
                    }
                    return "#" + date.toISOString() + "#";
                };
                var buildQueryForStringValue = function () {
                    switch (operator) {
                        case "eq":
                            queryString += _.str.sprintf("%s = '%s'", field, value);
                            break;
                        case "neq":
                            queryString += _.str.sprintf("%s <> '%s'", field, value);
                            break;
                        case "contains":
                            queryString += _.str.sprintf("%s LIKE '%%%s%%'", field, value);
                            break;
                        case "doesnotcontain":
                            queryString += _.str.sprintf("%s NOT LIKE '%%%s%%'", field, value);
                            break;
                        case "startswith":
                            queryString += _.str.sprintf("%s LIKE '%s%%'", field, value);
                            break;
                        case "endswith":
                            queryString += _.str.sprintf("%s LIKE '%%%s'", field, value);
                            break;
                        default:
                            throw "Invalid operator for string value!";
                    }
                }
                var buildQueryForDateValue = function () {
                    var dtStart = new Date(value.valueOf());
                    var dtEnd = new Date(value.valueOf());
                    dtStart.setHours(0);
                    dtStart.setMinutes(0);
                    dtStart.setSeconds(0);
                    dtStart.setMilliseconds(0);
                    dtEnd.setHours(23);
                    dtEnd.setMinutes(59);
                    dtEnd.setSeconds(59);
                    dtEnd.setMilliseconds(999);
                    var omqlStart = omqlDateString(dtStart);
                    var omqlEnd = omqlDateString(dtEnd);

                    switch (operator) {
                        case "eq":
                            queryString += _.str.sprintf("%s >= %s AND %s <= %s", field, omqlStart, field, omqlEnd);
                            break;
                        case "neq":
                            queryString += _.str.sprintf("%s <= %s AND %s >= %s", field, omqlStart, field, omqlEnd);
                            break;

                        case "gt":
                            queryString += _.str.sprintf("%s > %s", field, omqlEnd);
                            break;
                        case "gte":
                            queryString += _.str.sprintf("%s >= %s", field, omqlStart);
                            break;
                        case "lt":
                            queryString += _.str.sprintf("%s < %s", field, omqlStart);
                            break;
                        case "lte":
                            queryString += _.str.sprintf("%s <= %s", field, omqlEnd);
                            break;
                        default:
                            throw "Invalid operator for datetime value!";
                    }
                }
                var buildQueryForNumberValue = function () {
                    switch (operator) {
                        case "eq":
                            queryString += _.str.sprintf("%s = %s", field, value);
                            break;
                        case "neq":
                            queryString += _.str.sprintf("%s <> %s", field, value);
                            break;
                        case "gt":
                            queryString += _.str.sprintf("%s > %s", field, value);
                            break;
                        case "gte":
                            queryString += _.str.sprintf("%s >= %s", field, value);
                            break;
                        case "lt":
                            queryString += _.str.sprintf("%s < %s", field, value);
                            break;
                        case "lte":
                            queryString += _.str.sprintf("%s <= %s", field, value);
                            break;
                        default:
                            throw "Invalid operator for number value!";
                    }
                }
                var buildQueryForBooleanValue = function () {
                    queryString += _.str.sprintf("%s = %s", field, value);
                }

                if (_.isDate(value)) {
                    buildQueryForDateValue();
                } else if (_.isNumber(value)) {
                    buildQueryForNumberValue();
                } else if (_.isBoolean(value)) {
                    buildQueryForBooleanValue();
                } else {
                    buildQueryForStringValue();
                }

                return queryString;
            }
        }
    );
